import React from 'react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import {
  LayoutGrid, List, Plus, DollarSign, Calendar, Activity, RefreshCw, X, Trash2,
} from 'lucide-react';

export const CasoMovimientosTab = ({
  movimientosDetalle, loadingMovimientos, vistaElementos, setVistaElementos,
  onOpenSearch, onRemoveMovimiento,
}) => (
  <div>
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        <Button variant={vistaElementos === 'cards' ? 'default' : 'outline'} size="sm" onClick={() => setVistaElementos('cards')}><LayoutGrid size={14} /></Button>
        <Button variant={vistaElementos === 'list' ? 'default' : 'outline'} size="sm" onClick={() => setVistaElementos('list')}><List size={14} /></Button>
      </div>
      <Button size="sm" onClick={onOpenSearch} style={{ backgroundColor: '#22c55e' }}>
        <Plus size={14} className="mr-1" /> Agregar Movimiento
      </Button>
    </div>
    {loadingMovimientos ? (
      <div className="flex items-center justify-center py-8"><RefreshCw className="animate-spin text-green-500" size={24} /></div>
    ) : movimientosDetalle.length === 0 ? (
      <div className="text-center py-8 text-slate-400">
        <Activity size={40} className="mx-auto mb-2 opacity-50" />
        <p>No hay movimientos vinculados a este caso</p>
        <Button variant="outline" size="sm" className="mt-3" onClick={onOpenSearch}><Plus size={14} className="mr-1" /> Agregar primer movimiento</Button>
      </div>
    ) : vistaElementos === 'cards' ? (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {movimientosDetalle.map(mov => (
          <div key={mov.id || mov.id_coelsa} className="p-4 bg-green-50 rounded-lg border border-green-200 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-2">
              <Badge className="bg-green-100 text-green-700">{mov.tipo_operacion || mov.tipo || 'Movimiento'}</Badge>
              <button onClick={() => onRemoveMovimiento(mov.id || mov.id_coelsa)} className="p-1 rounded hover:bg-red-100 text-red-500"><X size={14} /></button>
            </div>
            <div className="flex items-center gap-2 mb-2">
              <DollarSign size={16} className="text-green-600" />
              <span className="font-bold text-lg text-green-700">${(mov.monto || mov.importe || 0).toLocaleString()}</span>
            </div>
            <p className="text-xs text-slate-600"><span className="font-medium">CUIT:</span> {mov.cuit || mov.cuit_ordenante || 'N/A'}</p>
            <div className="flex items-center gap-2 mt-2 text-xs text-slate-400">
              <Calendar size={12} />{mov.fecha ? new Date(mov.fecha).toLocaleDateString() : 'Sin fecha'}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="space-y-2">
        {movimientosDetalle.map(mov => (
          <div key={mov.id || mov.id_coelsa} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg hover:bg-slate-100">
            <div className="flex items-center gap-3">
              <DollarSign size={16} className="text-green-500" />
              <div>
                <p className="font-medium text-sm">${(mov.monto || mov.importe || 0).toLocaleString()}</p>
                <p className="text-xs text-slate-500">{mov.tipo_operacion || mov.tipo || 'Movimiento'} - {mov.cuit || mov.cuit_ordenante || 'N/A'}</p>
              </div>
            </div>
            <button onClick={() => onRemoveMovimiento(mov.id || mov.id_coelsa)} className="p-1 rounded hover:bg-red-100 text-red-500"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    )}
  </div>
);
